export default __webpack_public_path__ + "static/media/books-38.e33f1688.jpg";